import React from 'react';
import {
    CaretDownOutlined,
    ColorMode,
    useBreakpoint,
    Button,
    Popover,
} from '@landr/maestro';
import { KeyControl } from 'components/Creator/KeyControl';
import { KeyQuality } from 'types/enums';
import { KeyControlPopoverProps } from './KeyControlPopover.types';

export const KeyControlPopover = ({
    keyQuality,
    normalizedRootValue,
    isDisabled = false,
}: KeyControlPopoverProps): JSX.Element => {
    const isMobile = useBreakpoint('md');
    const iconRight = isMobile ? undefined : CaretDownOutlined;

    const abbreviatedKeyQuality = keyQuality === KeyQuality.Major ? '' : 'm';

    const fullRootAndQuality = `${normalizedRootValue} ${keyQuality}`;
    const abbrRootAndQuality = `${normalizedRootValue}${abbreviatedKeyQuality}`;
    const responsiveRootAndQuality = isMobile
        ? abbrRootAndQuality
        : fullRootAndQuality;

    return (
        <Popover placement="top-end">
            {({ close }): JSX.Element => (
                <>
                    <Popover.Trigger>
                        {/*
                        Note: Tooltip can't handle popover onClick, leave commented for now<Tooltip
                        position="top"
                        content={i18n._(t`Choose the key of your session`)}
                    > */}
                        <Button
                            variant="secondary"
                            isRounded
                            size="sm"
                            iconRight={iconRight}
                            isDisabled={isDisabled}
                        >
                            {responsiveRootAndQuality}
                        </Button>
                        {/* </Tooltip> */}
                    </Popover.Trigger>
                    <ColorMode mode="dark">
                        <Popover.Content py={0} px={0}>
                            <KeyControl onClick={close} />
                        </Popover.Content>
                    </ColorMode>
                </>
            )}
        </Popover>
    );
};
